<app-page-container>
  <div class="opcoes">
    <app-header appTitle="Histórico de Chamados">
      <div class="sub-titulo" *ngIf="autorizacoes.listarEquipamentos;">
        <span><b>Deseja abrir um novo chamado?</b> Selecione o
          <a class="equipamento-link" routerLink="/equipamento/abrir-chamado/1">equipamento</a>
          e inicie seu
          pedido</span>
        <br>
        <!-- <div *ngIf="token.tipoUsuario ==='INT'">
          <span>Deseja gerenciar os chamados? <a class="equipamento-link" routerLink="/equipamentos">clique
              aqui</a></span>
        </div> -->
      </div>

      <div class="tab-navegacao">
        <button routerLink="/historico-chamados" class="ml-4" *ngIf="autorizacoes.listarChamadosAndamento">Em
          andamento</button>
        <button class="button__styles" *ngIf="autorizacoes.listarChamadosFinalizados">Concluídos</button>
      </div>

      <div class="filtrar my-2">
        Filtrar
      </div>


      <form [formGroup]="filtraForm" (submit)="{}" class="form-filtro-historico-chamados">
        <input id="FiltroPesquisar" name="FiltroPesquisar" class="form-control mr-sm-2 my-sm-0" type="search"
          aria-label="Pesquisar" formControlName="FiltroPesquisar" placeholder="Pesquisar...">
        <div class="d-flex align-items-end">
          <button class="btn btn-primary" type="button" (click)="getHistoricoChamadosFinalizados(true)">Buscar</button>
        </div>
        <app-filtro-generico [filterInputs]="[
          { label: 'Patrimônio', formControlName: 'patrimonio' },
          { label: 'Contrato', formControlName: 'contrato' },
          { label: 'Número de Serie', formControlName: 'numserie' },
        ]" [selectInputs]="[
        { label: 'Site', formControlName: 'site', options: sitesOptions.registros, exibir: exibirSite, valor: valorSite}
        ]" [showOptions]="true" (OnClickApplyButton)="getHistoricoChamadosFinalizados(true)"
          (filterData)="receiveFilterData($event)"></app-filtro-generico>
      </form>
    </app-header>

    <app-tabela
      [cabecalhos]="['Cód Contrato', 'OS de Origem', 'OS Atual', 'Data de Abertura', 'Cliente', 'N° de Série', 'Patrimônio', 'Aberto por', 'Status', 'Ações']"
      [items]="chamados.registros" [colunasOcultas]="['OS de Origem', 'OS Atual', 'Ações']" [condicoesColunas]="[{ columnName: 'OS de Origem', condition: autorizacoes.exibirDetalhesChamado },
                                     { columnName: 'OS Atual', condition: autorizacoes.exibirDetalhesChamado },
                                     { columnName: 'Ações', condition: autorizacoes.exibirDetalhesChamado }]">
      <tr *ngFor="let chamado of chamados.registros">
        <td>{{ chamado.codigoContrato ?? 'Sem dados'}}</td>
        <td *ngIf="autorizacoes.exibirDetalhesChamado">
          <button *ngIf="chamado.temOsRetorno; else retornoOSNA" class="visualizar-btn"
            [routerLink]="['/historico-de-chamados', chamado.numserie, chamado.codigoContrato]"
            [queryParams]="{codigoOs: chamado.retornoOS}">
            {{chamado.retornoOS}}
          </button>
        </td>
        <td *ngIf="autorizacoes.exibirDetalhesChamado">
          <button *ngIf="autorizacoes.exibirDetalhesChamado" class="visualizar-btn"
            [routerLink]="['/historico-de-chamados', chamado.numserie, chamado.codigoContrato]"
            [queryParams]="{codigoOs: chamado.codigoOS}">
            {{chamado.codigoOS}}
          </button>
        </td>
        <td>{{ chamado.dataAbertura | date:'dd/MM/yyyy' }}</td>
        <td>{{ chamado.nomeFantasia || chamado.nomeCliente || 'Sem dados'}}</td>
        <td>{{ chamado.numserie ?? 'Sem dados' }}</td>
        <td>{{ chamado.numpat ?? 'Sem dados' }}</td>
        <td>{{ chamado.solicitante || 'Sem dados'}}</td>
        <td>{{ chamado.status || 'Sem dados'}}</td>
        <td *ngIf="autorizacoes.exibirDetalhesChamado">
          <button class="visualizar-btn" *ngIf="autorizacoes.exibirDetalhesChamado"
            [routerLink]="['/historico-de-chamados', chamado.numserie, chamado.codigoContrato]">
            Visualizar</button>
        </td>
      </tr>
    </app-tabela>
    <app-paginacao nomeDaLista="Chamados" [(dados)]="chamados" (dadosChange)="getHistoricoChamadosFinalizados()"
      *ngIf="this.chamados.registros.length !== 0"></app-paginacao>

  </div>
</app-page-container>
<ng-template #retornoOSNA>Sem dados</ng-template>